module.exports = __webpack_public_path__ + "media/img/events/location/bicycle-1247a2bc87cf7fcf2de4c35d1f24f87a.svg";